import React, { Component } from "react";
import { Switch, withRouter, Route, Link } from "react-router-dom";
import _ from "lodash";
import {
  Container,
  Row,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'flatpickr/dist/flatpickr.css';
import Select from 'react-select';
import classNames from "classnames";
import Product from "../Product/Product.js";
import spacer from "../../assets/spacer.png";
import jsPDF from "jspdf/dist/jspdf.debug.js";
import htmlDocx from "html-docx-js/dist/html-docx.js";
import juice from "juice";
//import fileSaver from "file-saver";
import wordsToNumbers from 'words-to-numbers';
import numberToWords from 'number-to-words';
import ReactHtmlParser from "react-html-parser";
import moment from 'moment';
import ProductDetail from "../Product/ProductDetail";

const jsforce = require('jsforce');
const dateFormats = {flatPickr: 'n/j/Y', formValue: 'M/D/YYYY'};

let conn;

function filter(text){

  let val = text;
  if(!val && typeof(val) === 'string'){
    return undefined;
  }
  if(!val || typeof(val) !== 'string'){
    return text;
  }
  if(val[0] === "\""){
    val = JSON.parse(val);
  }
  if(val === ""){
    return undefined;
  }
  return val;
}

class ProposalBuilder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      isGrid: true,
      hasSubmitted: false,
      priceFilter: {
        min: 0,
        max: 0
      },
      priceMax: 0,
      searchQuery: "",
      categorySelection: {},
      uniqueCategories: [],
      categoryParents: [],
      featuredProducts: [],
      sowBuilderProducts: [],
      selectedProductOptions: {},
      sowBuilderTotalPrice: 0,
      sowBuilderTotalHours: 0,
      sowBuilderTotalWeeks: 0,
      sowBuilderCurrentDate: new Date(),
      sowBuilderDate: moment().add(30, 'days').format(dateFormats.formValue),
      sowBuilderDateOpen: true,
      sowBuilderTerms: "",
      sowBuilderSignature: "",
      sowBuilderPreviewShowing: false,
      sowBuilderPreviewHeight: 400,
      sowBuilderDownloadDocType: "word",
      sowBuilderClient: '',
      sowBuilderClientError: false,
      createProposalDropdownOpen: false,
      accounts: [],
      sfAccountText: '',
      salesforce: {
        closeDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 7),
        revenuedept: [],
        edition: [],
      },
      oppError: undefined,
      isSfModalOpen: false,
      sfLoading: false,
      quantity: 0,
    };

    this.handleSearchQueryChange = this.handleSearchQueryChange.bind(this);
    this.setSfModalListener = this.setSfModalListener.bind(this);
    this.toggleSfModal = this.toggleSfModal.bind(this);
    this.getProductOptionState = this.getProductOptionState.bind(this);
    this.clearError = this.clearError.bind(this);
    this.handleSearchClear = this.handleSearchClear.bind(this);
    this.handleCategorySelect = this.handleCategorySelect.bind(this);
    this.setPriceFilter = this.setPriceFilter.bind(this);
    this.setGridView = this.setGridView.bind(this);
    this.setListView = this.setListView.bind(this);
    this.backToPage = this.backToPage.bind(this);
    this.formatPriceFilterLabel = this.formatPriceFilterLabel.bind(this);
    this.renderProductPriceTime = this.renderProductPriceTime.bind(this);
    this.handleProductOptionSelection = this.handleProductOptionSelection.bind(this);
    this.handleSowBuilderAdd = this.handleSowBuilderAdd.bind(this);
    this.isSowBuilderAdded = this.isSowBuilderAdded.bind(this);
    this.handleSowBuilderDateOpen = this.handleSowBuilderDateOpen.bind(this);
    this.handleSowBuilderDateClose = this.handleSowBuilderDateClose.bind(this);
    this.handleSowBuilderRemove = this.handleSowBuilderRemove.bind(this);
    this.isSowBuilderTermsSignatureOption = this.isSowBuilderTermsSignatureOption.bind(this);
    this.toggleSowBuilderPreview = this.toggleSowBuilderPreview.bind(this);
    this.getSowBuilderSummary = this.getSowBuilderSummary.bind(this);
    this.setSowBuilderSummaryRef = this.setSowBuilderSummaryRef.bind(this);
    this.isSowBuilderPreviewShowing = this.isSowBuilderPreviewShowing.bind(this);
    this.setSowBuilderPreviewHeight = this.setSowBuilderPreviewHeight.bind(this);
    this.handleSowBuilderDownload = this.handleSowBuilderDownload.bind(this);
    this.isSowBuilderEmpty = this.isSowBuilderEmpty.bind(this);
    this.isSowBuilderLimit = this.isSowBuilderLimit.bind(this);
    this.toggleSaveProposalDropdown = this.toggleSaveProposalDropdown.bind(this);
    this.submitProposal = this.submitProposal.bind(this);
    this.createProposal = this.createProposal.bind(this);
    this.updateProposal = this.updateProposal.bind(this);
    this.sfHandleAccountChange = this.sfHandleAccountChange.bind(this);
    this.sfHandleAccountInputChange = this.sfHandleAccountInputChange.bind(this);
    this.toggleCreateProposalConfirm = this.toggleCreateProposalConfirm.bind(this);
    this.jumpCreateProposalConfirm = this.jumpCreateProposalConfirm.bind(this);
    this.jumpCreateProposalConfirmProposals = this.jumpCreateProposalConfirmProposals.bind(this);
    this.handleProposalQuoteCreate = this.handleProposalQuoteCreate.bind(this);
    this.renderProposalBuilder = this.renderProposalBuilder.bind(this);
  }

  componentDidMount() {
    if(this.props.isSalesforce){
      conn = new jsforce.Connection({ accessToken: localStorage.getItem('sf_session') });
    }
    const items = this.props.data.contents.items;
    if (items) {
      //populate category arrays
      const uniqueCategories = [];
      items.forEach(item => {
        item.categories.forEach(cat => {
          const currNames = uniqueCategories.map(cat => cat.name);
          if (!currNames.includes(cat.name)) {
            uniqueCategories.push(cat);
          }
        });
      });
      this.setState({ uniqueCategories: uniqueCategories });
      const categoryParents = [];
      uniqueCategories.forEach(cat => {
        const selected = this.state.categorySelection;
        selected[cat.name] = false;
        this.setState({ selected });
        if (cat.parent_name && !categoryParents.includes(cat.parent_name)) {
          categoryParents.push(cat.parent_name);
        }
      });
      this.setState({ categoryParents: categoryParents });
      this.setState({ itemList: items });

      //calculate priors for price filter
      const maxPrice = Math.max.apply(Math, items.map(card => card.points));
      this.setState({ priceMax: maxPrice });
      this.setState({ priceFilter: { min: 0, max: maxPrice } });

      //filter out featuredProducts that wont be otherwise filterable
      this.setState({ featuredProducts: items.filter(product => product.is_featured === true) });

      if(this.props.data.terms) {
        this.setState({ sowBuilderTerms: this.props.data.terms.setting_value });
      }
      const signature = this.props.data.settings.find(s => s.setting_key === 'signature_block_text');
      if(signature) {
        this.setState({ sowBuilderSignature: signature.setting_value });
      }
    }

    if(this.props.editProposal) {
      //this.props.setPageProposals(false);
      const settings = this.props.editProposal.settings;
      this.setState({
        sowBuilderClient: settings.clientName,
        sowBuilderDate: settings.expiryDate,
        sowBuilderName: settings.name,
        sowBuilderEmail: settings.email
      });

      if (settings.items) {
        settings.items.forEach(savedItemId => {
          const item = items.find(item => item.id === savedItemId);
          this.handleSowBuilderAdd(item);
        });
      }
      if (settings.options) {
        Object.keys(settings.options).forEach(rowId => {
          this.handleProductOptionSelection({id: rowId}, settings.options[rowId]);
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if(_.get(prevProps, 'proposalCreate.pending') && !_.get(this.props, 'proposalCreate.pending')) {
      //this.toggleCreateProposalConfirm();
      //this.setState({ proposalSubmitting: false });
      //this.handleProposalQuoteCreate(this.props.proposalCreate.value.data);
    }
    if(_.get(prevProps, 'proposalUpdate.pending') && !_.get(this.props, 'proposalUpdate.pending')) {
      this.setState({ proposalSubmitting: false });
      this.handleProposalQuoteCreate(this.props.proposalUpdate.value.data);
    }
  }

  handleSearchQueryChange(event) {
    const val = event.target.value.toLowerCase();
    this.setState({ searchQuery: val });
  }
  handleSearchClear() {
    this.setState({ searchQuery: "" });
  }

  setPriceFilter(value) {
    value.min = Math.max(value.min, 0);
    value.max = Math.min(value.max, this.state.priceMax);
    this.setState({ priceFilter: value });
  }

  isPriceFiltered() {
    return (
        this.state.priceFilter.min > 0 ||
        this.state.priceFilter.max < this.state.priceMax
    );
  }

  formatPriceFilterLabel(value) {
    const normalizedValue = value >= 1000 ? value / 1000 + "k" : value;
    return `${normalizedValue} ${this.state.priceUnit}${
        value !== 1 ? "s" : ""
        }`;
  }

  setGridView() {
    this.setState({ isGrid: true });
  }

  setListView() {
    this.setState({ isGrid: false });
  }

  renderProductPriceTime(item, opts) {
    opts = opts || {};

    const priceDurationRow = item.rows && item.rows.find(row => row.label === 'Pricing and Duration');
    if(priceDurationRow && priceDurationRow.control) {
      const control = JSON.parse(priceDurationRow.control);
      if(control.schedule) {
        item.service_rate_cents = control.schedule.cost;
        item.duration = control.schedule.duration/3600;
      }
    }
    const price = (opts.option && item.value ? item.value.price : item.service_rate_cents/100 || item._price ) || 0;
    const quantityRow = item.rows && item.rows.find((row) => row.label === 'Quantity')
    const quantity = parseInt(quantityRow.control, 10)
    const salesPriceRow = item.rows && item.rows.find((row) => row.label === 'Sales Price')
    const salesPrice = filter(salesPriceRow.control) !== undefined ? parseFloat(salesPriceRow.control) : price
    const weeks = Math.round(((opts.option && item.value ? item.value.hours : item.duration || item._hours) / 40) * 2) / 2 || 0;
    const renderPrice = `$${(opts.quantity ? (salesPrice !== undefined ? salesPrice : price) : price).toLocaleString()}`;
    const renderWeeks = weeks ? `${weeks.toLocaleString()} week${weeks !== 1 ? "s" : ""}` : null;
    const discount = 100 - Math.min(100, Math.round((salesPrice / price) * 100))
    const total = (salesPrice !== undefined ? salesPrice : price) * (quantity || 1)

    if (price || weeks) {
      return (
        <div className="priceTime">
          {opts.quantity
              ? <span>
                {renderPrice} x {quantity || 1} {Boolean(discount) && <span className='text-italic'>({discount}% off)</span>}
                <hr style={{ margin: '4px 0' }} />
                <span>${total.toLocaleString()}</span>
              </span>
              : [
                price ? <span key={`p${item.id}`}>{renderPrice}</span> : null,
                (opts.download || opts.preview) && !opts.option && weeks ? <span key={`d${item.id}`}>{renderWeeks}</span> : null
              ]
          }
        </div>
      );
    }
  }


  backToPage(e) {
    if(this.props.editProposal) {
      e.preventDefault();
      e.stopPropagation();
      this.props.setPageDetail();
      return;
    }
    this.props.setPageProposals(false);
  }



  getItems(){
    let itemList = this.props.data.contents.items;

    if(!itemList){
      return null;
    }

    //handle category filtering
    if(this.state.categorySelection.length){
      itemList = itemList.filter(item => item.categories.some(cat => this.state.categorySelection.includes(cat.id)));
      if(itemList.length === 0){
        return <h3 className="error">Your selected categories have no associated items.</h3>
      }
    }

    itemList = itemList.filter(card => card.name.toLowerCase().indexOf(this.state.searchQuery) !== -1 || card.description.toLowerCase().indexOf(this.state.searchQuery) !== -1);


    if(itemList.length === 0){
      if(this.state.searchQuery !== ''){
        return <h3 className="error">Your search query did not produce any results. Please try again.</h3>
      }else{
        return <h3 className="error">Your price filter did not produce any results. Please try again.</h3>
      }
    }

    const display = this.state.isGrid;
    return(
        <Row className="items">
          {itemList.map((item, index) => {
            return(
                <Product
                    log_transaction={this.props.log_transaction}
                    data={item}
                    index={index}
                    key={index}
                    isGrid={display}
                    renderProductPriceTime={this.renderProductPriceTime}
                    setPageDetail={this.props.setPageDetail}
                    isSowBuilderAdded={this.isSowBuilderAdded}
                    handleSowBuilderAdd={this.handleSowBuilderAdd}
                    handleSowBuilderRemove={this.handleSowBuilderRemove}
                    isSowBuilderLimit={this.isSowBuilderLimit}
                    editProposal={this.props.editProposal}
                />
            );
          })}
        </Row>
    );
  }

  handleCategorySelect(categorySelection) {
    this.setState({ categorySelection: categorySelection.map(cat => cat.value) });
  }

  handleProductOptionSelection(row, value) {
    const { selectedProductOptions } = this.state;
    selectedProductOptions[row.id] = value;
    row.control = value

    this.setState({ selectedProductOptions });
    this.calcSowBuilderSummary();
  }
  getProductOptionState(row){
    return this.state.selectedProductOptions[row.id];
  }




  handleSowBuilderAdd(product, e) {
    if(e)
      e.preventDefault();
    const { sowBuilderProducts } = this.state;
    sowBuilderProducts.push(product);

    this.setState({ sowBuilderProducts: sowBuilderProducts }, () => {
      this.calcSowBuilderSummary();
    });

    /*if (!this.isSowBuilderPreviewShowing()) {
      this.toggleSowBuilderPreview();
    }*/
  }

  handleSowBuilderRemove(product, e) {
    if (e) e.preventDefault();

    const { sowBuilderProducts } = this.state;
    sowBuilderProducts.splice(sowBuilderProducts.indexOf(product), 1);
    this.setState({ sowBuilderProducts: sowBuilderProducts }, () => {
      this.calcSowBuilderSummary();
    });

    if (
        !this.state.sowBuilderProducts.length &&
        this.isSowBuilderPreviewShowing()
    ) {
      this.toggleSowBuilderPreview();
    }
  }

  isSowBuilderAdded(product) {
    const { sowBuilderProducts } = this.state;
    return sowBuilderProducts.indexOf(product) !== -1;
  }

  isSowBuilderPreviewShowing() {
    return this.state.sowBuilderPreviewShowing;
  }

  isSowBuilderEmpty() {
    return !this.state.sowBuilderProducts.length;
  }

  isSowBuilderLimit(row) {
    return (this.state.selectedProductOptions[row.id]||[]).length === 3;
  }

  toggleSowBuilderPreview() {
    let { sowBuilderPreviewShowing } = this.state;
    sowBuilderPreviewShowing = !sowBuilderPreviewShowing;
    this.setState({ sowBuilderPreviewShowing: sowBuilderPreviewShowing });

    //if (!this.props.detailItem && !this.props.editProposal) this.props.isDimmed(sowBuilderPreviewShowing);
  }

  setSowBuilderPreviewHeight() {
    const sowBuilderSummaryElem = document.getElementsByClassName(
        "sowBuilderSummary"
    )[0];
    if (sowBuilderSummaryElem) {
      const sowBuilderSummaryRect = sowBuilderSummaryElem.getBoundingClientRect();
      this.setState({
        sowBuilderPreviewHeight:
            window.innerHeight - sowBuilderSummaryRect.top - 150
      });
    }
  }

  getSowBuilderDownloadId() {
    return "sowBuilderDownload" + (this.props.editProposal ? this.props.editProposal.id : "");
  }

  buildSowBuilderDownloadVariable(name, opts) {
    return `&lt;${opts && opts.closingTag ? "/" : ""}${name}&gt;`;
  }

  buildSowBuilderDownloadVariableTagRegex(name) {
    return new RegExp(
        this.buildSowBuilderDownloadVariable(name) +
        "(.*?)" +
        this.buildSowBuilderDownloadVariable(name, { closingTag: true }),
        "g"
    );
  }

  handleSowBuilderDownloadSigField(field) {
    const fieldLeft =
        field === "Customer" ? this.state.sowBuilderClient : field;
    return (
        "<pre>" +
        fieldLeft +
        "&#9;".repeat(5 - Math.floor(Math.max(0, fieldLeft.length - 2) / 10)) +
        (field === "Customer" ? "Gainsight" : field) +
        '</pre><br><br><pre style="font-family:Arial !important;">___________________________________________&#9;___________________________________________</pre><br><div class=sigFieldSep></div>'
    );
  }

  handleSowBuilderDownloadPageBreak(html) {
    return html.replace(
        new RegExp(this.buildSowBuilderDownloadVariable("Page Break"), "g"),
        '<br class="pagebreak" clear="all" style="page-break-before:always" />'
    );
  }

  handleSowBuilderDownloadExhibitVariables(item, opts) {
    opts.elem.innerHTML = opts.elem.innerHTML
        .replace(this.buildSowBuilderDownloadVariable('Price'), '$' + item._price.toLocaleString())
        .replace(this.buildSowBuilderDownloadVariable('Weeks'), item._quarter ? `Consecutive ${item._quarter} quarter${item._quarter !== 1 ? 's' : ''} (${item._weeks} weeks)` : item._weeks + ' weeks')
        .replace(this.buildSowBuilderDownloadVariable('Hours'), item._quarter ? `${item._quarter_hours} hours (${Math.ceil(item._quarter_hours/item._weeks)} hours per week)` : item._hours + ' hours')
        .replace(this.buildSowBuilderDownloadVariable('Item Name'), `<center>${item.name}</center>`)
        .replace(this.buildSowBuilderDownloadVariable('Exhibit X'), `<center>${opts.exhibitLabel ? opts.exhibitLabel + ' ' : ''}${(opts.exhibitNum + 9).toString(36).toUpperCase()}</center>`);
  }

  cleanSowBuilderDownload(docType) {
    var sowBuilderDownloadId = this.getSowBuilderDownloadId();
    var stylesheet = "";
    for (var i in document.styleSheets) {
      if (
          document.styleSheets[i].href &&
          document.styleSheets[i].href.indexOf("SowBuilderDownload") !== -1
      ) {
        stylesheet = document.styleSheets[i];
      }
    }
    var styles = '';
    var classes = stylesheet.rules || stylesheet.cssRules;
    for (var s = 0; s < classes.length; ++s) {
      styles += classes[s].cssText;
    }
    var cleanElem = document.createElement("div");
    cleanElem.innerHTML = "<style>" + styles + "</style>" + document.getElementById(sowBuilderDownloadId).outerHTML;

    let exhibitNum = 0;
    [].forEach.call(cleanElem.querySelectorAll(".item"), n => {
      const product = this.state.sowBuilderProducts.find(p => p.id === n.getAttribute('data-id'));
      if (product) {
        this.handleSowBuilderDownloadExhibitVariables(product, {elem: n, exhibitLabel: 'Exhibit', exhibitNum: ++exhibitNum});

        const selectedOptionsRow = product.rows.find(r => (this.state.selectedProductOptions[r.id]||[]).length);
        if(selectedOptionsRow) {
          const selectedOptions = this.state.selectedProductOptions[selectedOptionsRow.id];
          const bundles = selectedOptions.length * 2;
          n.innerHTML = n.innerHTML.replace(this.buildSowBuilderDownloadVariable('Bundles'), `${numberToWords.toWords(bundles)} (${bundles})`);

          const components = {};
          selectedOptions.forEach(option => {
            const componentOptions = components[option.value.component] = components[option.value.component] || [];
            componentOptions.push(option.label);
          });
          let componentsHtml = '<ul>';
          for(const component in components) {
            componentsHtml += `<li>${component}<ul>${components[component].map(option => `<li>${option}</li>`).join('')}</ul></li>`;
          }
          componentsHtml += '</ul>';
          n.innerHTML = n.innerHTML.replace(this.buildSowBuilderDownloadVariable('Components'), componentsHtml);
        }
      }
    });


    const exhibitTableMatch = [].filter.call(cleanElem.querySelectorAll('td'), n => {
      return RegExp(this.buildSowBuilderDownloadVariable('Exhibit X')).test(n.innerHTML);
    });
    if(exhibitTableMatch.length) {
      const exhibitTableTemplateRow = exhibitTableMatch[0].parentNode;
      exhibitNum = this.state.sowBuilderProducts.length+1;
      this.state.sowBuilderProducts.slice().reverse().forEach(product => {
        const exhibitTableRow = exhibitTableTemplateRow.cloneNode(true);
        this.handleSowBuilderDownloadExhibitVariables(product, {elem: exhibitTableRow, exhibitNum: --exhibitNum});
        exhibitTableTemplateRow.parentNode.insertBefore(exhibitTableRow, exhibitTableTemplateRow.nextSibling);
      });
      exhibitTableTemplateRow.parentNode.removeChild(exhibitTableTemplateRow);
    }

    cleanElem.innerHTML = cleanElem.innerHTML
        .replace(/\n/g, ' ')
        .replace(this.buildSowBuilderDownloadVariable('Subtotal'), '$' + this.state.sowBuilderTotalPrice.toLocaleString())
        .replace(this.buildSowBuilderDownloadVariable('Total Price'), '$' + this.state.sowBuilderTotalPrice.toLocaleString())
        .replace(this.buildSowBuilderDownloadVariable('Total Weeks'), this.state.sowBuilderTotalWeeks + ' week' + (this.state.sowBuilderTotalWeeks !== 1 ? 's' : ''))
        .replace(this.buildSowBuilderDownloadVariable('Total Hours'), this.state.sowBuilderTotalHours)
        .replace(this.buildSowBuilderDownloadVariable('Expire Weeks'), (_.max(this.state.sowBuilderProducts.map(p => p._weeks)) + 13) + ' weeks')
        .replace(this.buildSowBuilderDownloadVariable('Date'), moment(this.state.sowBuilderDate).format(dateFormats.formValue))
        .replace(this.buildSowBuilderDownloadVariableTagRegex('Sig Field'), (match, field) => this.handleSowBuilderDownloadSigField(field))
        .replace(new RegExp(this.buildSowBuilderDownloadVariable('Customer'), 'g'), this.state.sowBuilderClient);

    if (docType !== 'word') {
      cleanElem.innerHTML = this.handleSowBuilderDownloadPageBreak(cleanElem.innerHTML);
    }

    /*var summaryElem = cleanElem.querySelector(".summary");
    summaryElem.parentNode.removeChild(summaryElem);*/
    var termsElem = cleanElem.querySelector(".terms .content");
    if(termsElem) {
      var headerEndsVariable = this.buildSowBuilderDownloadVariable('Header Ends');
      var termsHeaderElem = document.createElement('div');
      termsHeaderElem.classList.add("termsHeader");
      termsHeaderElem.innerHTML = termsElem.innerHTML.substring(0, termsElem.innerHTML.indexOf(headerEndsVariable)) +
          '<div><hr /><div class="sep">_____________________________________________________________________________________________________________</div></div>';
      termsElem.innerHTML = termsElem.innerHTML.substring(termsElem.innerHTML.indexOf(headerEndsVariable)).replace(headerEndsVariable, '');

      var logoElem = cleanElem.querySelector("#sowBuilderDownload > img");
      logoElem.parentNode.insertBefore(termsHeaderElem, logoElem.nextSibling);
    }

    [].forEach.call(cleanElem.querySelectorAll("ol"), function (n) {
      if(n.firstChild.tagName === 'LI' && n.firstChild.getAttribute('data-list') === 'bullet') {
        n.outerHTML = '<ul>' + n.innerHTML + '</ul>';
      }
    });

    if(docType === 'word') {
      [].forEach.call(cleanElem.querySelectorAll(".ql-align-center"), function (n) {
        n.innerHTML = '<center>' + n.innerHTML + '</center>';
      });
      [].forEach.call(cleanElem.querySelectorAll("hr"), function (n) {
        n.parentNode.removeChild(n);
      });
    }
    else {
      [].forEach.call(cleanElem.querySelectorAll("p, li"), function (n) {
        if(n.innerHTML === '&nbsp;') {
          n.parentNode.removeChild(n);
        }

        if(n.innerHTML === '<br>') {
          n.innerHTML = '';
          var indentSpacer = document.createElement("img");
          indentSpacer.setAttribute('src', spacer);
          n.appendChild(indentSpacer);
          n.className = 'emptyRow';
        }
      });
    }

    return cleanElem;
  }

  handleSowBuilderDownload(proposal, docType, e, forOpp) {
    if (docType && e) {
      e.stopPropagation();
    }
    docType = docType || this.state.sowBuilderDownloadDocType;
    this.setState({ sowBuilderDownloadDocType: docType });
    var downloadElem = document.getElementById(this.getSowBuilderDownloadId());
    downloadElem.classList.add("active");
    const filename = `${this.state.sowBuilderClient} - Gainsight Statement of Work #MO${moment().format('YYYYMMDD')}.V1`

    if (docType === "word") {
      downloadElem.classList.add("doc");

      var cleanElem = this.cleanSowBuilderDownload(docType);
      [].forEach.call(cleanElem.querySelectorAll("p"), function(p) {
        if (p.innerText.trim() === "" || (p.children.length === 1 && p.children[0].tagName === "BR")) {
          p.className = 'emptyRow';
          //p.parentNode.removeChild(p);
        }
      });

      var docHtml =
          "<!DOCTYPE html>" +
          "<html>" +
          "<body>" +
          this.handleSowBuilderDownloadPageBreak(juice(cleanElem.outerHTML)) +
          "</body>" +
          "</html>";

      var blob = htmlDocx.asBlob(docHtml, {
        orientation: "portrait",
        margins: { top: 720 }
      });
      var formData = new FormData();
      formData.append('file', blob, filename+'.docx');

      this.props.proposalQuoteLazyCreate(proposal, formData);
      //fileSaver.saveAs(blob, "Proposal.docx");

      downloadElem.classList.remove("active");
      downloadElem.classList.remove("doc");
    } else {
      downloadElem.classList.add("pdf");

      var pdf = new jsPDF("p", "pt", "letter");
      /*pdf.setLineWidth(1); pdf.setDrawColor(225, 225, 225); pdf.rect(10, 83, 200, 55);*/
      var margins = { top: 20, bottom: 20, left: 20, right: 20 };
      pdf.fromHTML(
          this.cleanSowBuilderDownload(docType),
          margins.left,
          margins.top,
          {
            width: 550
          },
          () => {
            var blob =  pdf.output('blob');
            var formData = new FormData();
            formData.append('file', blob, filename+'.pdf');
            this.props.proposalQuoteLazyCreate(proposal, formData);
            //pdf.save("Proposal.pdf");
            downloadElem.classList.remove("active");
            downloadElem.classList.remove("pdf");
          },
          margins
      );
    }
  }

  toAscii(str) {
    str = str.replace(/&(l|g)t;/g, '{$1t}');
    var tmp = document.createElement('textarea');
    tmp.innerHTML = str;
    str = tmp.value.replace(/[\u0100-\uffff]/g, ch => {
      switch (ch) {
        case "“":
        case "”�":
          return '"';
        case "’":
        case "‘":
          return "'";
        default:
          return "";
      }
    });
    str = str.replace(/{(l|g)t}/g, '&$1t;');
    return str;
  }

  isSowBuilderTermsSignatureOption(option) {
    return option.terms || option.signature;
  }

  calcSowBuilderSummary() {
    let totalPrice = 0,
        totalHours = 0,
        totalWeeks = 0;

    const { sowBuilderProducts, selectedProductOptions } = this.state;
    sowBuilderProducts.forEach(product => {
      if (this.isSowBuilderTermsSignatureOption(product)) {
        return;
      }

      let price = 0;
      let hours = product.duration || 0;
      if (product.service_rate_cents) {
        const quantityRow = product.rows && product.rows.find((row) => row.label === 'Quantity')
        const quantity = parseInt(this.state.selectedProductOptions[quantityRow.id], 10)
        const salesPriceRow = product.rows && product.rows.find((row) => row.label === 'Sales Price')
        const salesPrice = filter(this.state.selectedProductOptions[salesPriceRow.id]) !== undefined ? parseFloat(this.state.selectedProductOptions[salesPriceRow.id]) : product.service_rate_cents / 100
        price += salesPrice * (quantity || 1)
      }
      else {
        const assistedOptionsRow = product.rows.find(row => row.row_type === 'checkbox' && row.label.toLowerCase().startsWith('assisted'));
        const enterpriseOptionsRow = product.rows.find(row => row.row_type === 'checkbox' && row.label.toLowerCase().startsWith('enterprise'));
        if(assistedOptionsRow) {
          const assistedOptionsSelected = this.state.selectedProductOptions[assistedOptionsRow.id] || [];
          if (assistedOptionsSelected.length) {
            hours += 4 * assistedOptionsSelected.length * 40;
            assistedOptionsSelected.map(o => o.value).forEach(o => {
              price += o.price;
            });
          }
        }
        else if(enterpriseOptionsRow) {
          const enterpriseOptionsSelected = this.state.selectedProductOptions[enterpriseOptionsRow.id]||[];
          if(enterpriseOptionsSelected.length) {
            hours += (6 + 2 * enterpriseOptionsSelected.length) * 40;
            enterpriseOptionsSelected.map(o => o.value).forEach(o => {
              price += o.price;
            });
          }
        }

        else {
          let pricingRow = product.rows.find(row => row.row_type === "component:pricing");
          if(pricingRow) {
            pricingRow = JSON.parse(pricingRow.control);
            if(pricingRow) {
              let selectedQuarters = 0;
              let selectedHours = 0;
              let selectedHoursTotal = 0;
              product.rows.forEach(row => {
                const selectedProductOption = selectedProductOptions[row.id];
                if(selectedProductOption) {
                  let value = parseInt(selectedProductOption.label.replace(/[^\d]/g, ''));
                  if(value) {
                    if (row.row_type === "dropdown" && row.label.toLowerCase().includes('quarter')) {
                      selectedQuarters = product._quarter = selectedProductOption.value.quarter;
                      hours = selectedProductOption.value.hours;
                    } else if (row.row_type === "dropdown" && row.label.toLowerCase().includes('hour')) {
                      if(selectedQuarters) {
                        selectedHours = value;
                        value = selectedProductOption.value.find(v => v.quarter === selectedQuarters);
                        if(value) {
                          selectedHoursTotal = product._quarter_hours = value.hours;
                        }
                      }
                    }
                  }
                }
              });
              pricingRow.constants.forEach(constant => {
                const m = /^q_(.*?)_hours_(.*)$/.exec(constant.name);
                if(m) {
                  const q = wordsToNumbers(m[1].replace('_', ' '));
                  const h = wordsToNumbers(m[2].replace('_', ' '));
                  if(q === selectedQuarters && h === selectedHours) {
                    price = constant.value/100 * selectedHoursTotal;
                  }
                }
              });
              //hours = selectedHoursTotal;
            }
          }
        }
      }

      product._price = price;
      product._hours = hours;
      product._weeks = Math.round((hours / 40) * 2) / 2;
      totalPrice += product._price;
      totalHours += product._hours;
      totalWeeks += product._weeks;
    });

    this.setState({
      sowBuilderTotalPrice: totalPrice,
      sowBuilderTotalHours: totalHours,
      sowBuilderTotalWeeks: totalWeeks
    });
  }

  handleSowBuilderDateOpen(dateObj, dateStr, instance) {
    this.setState({sowBuilderDateOpen: true}, () => {
      if(!this.state.sowBuilderDate) {
        instance.jumpToDate(moment().add(30, 'days').format(dateFormats.formValue));
      }
    });
  }

  handleSowBuilderDateClose() {
    this.setState({sowBuilderDateOpen: false});
  }

  handleSowBuilderClientChange(event) {
    this.setState({
      sowBuilderClient: event.target.value
    });
  }

  handleSowBuilderDateChange(value) {
    this.setState({
      sowBuilderDate: moment(value[0]).format(dateFormats.formValue)
    });
  }

  setSfModalListener(func){
    this.setState({sfListenFunc: func});
  }

  toggleSfModal(){
    if(this.state.sfLoading){
      return;
    }

    if(this.state.sfListenFunc){
      this.state.sfListenFunc();
    }

    if(!this.state.hasSubmitted){
      this.setState({hasSubmitted: true});
    }

    /*if(!this.state.isSfModalOpen){
      this.handleSowBuilderDownload('word', undefined, true);
      this.handleSowBuilderDownload('pdf', undefined, true);
    }

    if(this.state.finalMsg){
      this.setState({finalMsg: undefined});
      this.setState({isSfModalOpen: true});
      return;
    }*/

    if(!this.areFieldsValid()){
      this.setState({oppError: 'Please fill out all required fields'});
      return;
    }
    this.setState({isSfModalOpen: !this.state.isSfModalOpen});
  }

  getSowBuilderSummary() {
    return (
        <div
            ref={this.setSowBuilderSummaryRef}
            className={`sowBuilderSummary ${this.isSowBuilderPreviewShowing() ? "preview-showing" : ""} ${this.state.sowBuilderProducts.length ? "has-products" : ""}`}
        >
          <div className="cta">
            {this.props.isSalesforce ?
                <button color="primary" className={classNames('save', { submitting: this.state.proposalSubmitting })} onClick={this.toggleSfModal}>Create Opportunity</button>
                :
                this.props.editProposal ?
                  <Button color="primary" className={classNames('save', { submitting: this.state.proposalSubmitting })} onClick={this.updateProposal}>Save</Button> :
                  <Dropdown isOpen={this.state.createProposalDropdownOpen} toggle={this.toggleSaveProposalDropdown}>
                    <DropdownToggle caret className={classNames('save', { submitting: this.state.proposalSubmitting })}>
                      Save
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem className="draft" onClick={() => this.createProposal('draft')}>As Draft</DropdownItem>
                      <DropdownItem className="word" onClick={() => this.createProposal('quoteWord')}>As Quote</DropdownItem>
                      {/*<DropdownItem className="pdf" onClick={() => this.createProposal('quotePdf')}>As Quote</DropdownItem>*/}
                    </DropdownMenu>
                  </Dropdown>
              }
            <button
                className="preview"
                onClick={() => this.toggleSowBuilderPreview()}
            >
              <div className="label">Summary</div>
            </button>
            <Modal isOpen={this.state.createProposalConfirmOpen} toggle={this.toggleCreateProposalConfirm} className="createProposalConfirm">
              <ModalBody>
                <label>You have successfully submitted your SOW!</label>
                <div className="actions">
                  <Button color="secondary"><Link to="/" onClick={this.jumpCreateProposalConfirm}>Return to Catalog</Link></Button>
                  <Button color="primary"><Link to="/proposals" onClick={this.jumpCreateProposalConfirmProposals}>Go to My SOWs</Link></Button>
                </div>
              </ModalBody>
            </Modal>
          </div>
          <div className="summary">
            {this.state.sowBuilderProducts.length ?
                <div className="variables">
                  {this.props.isSalesforce ?
                      <div>
                        <Select clearable={true} placeholder="Account Name" noOptionsMessage={() => this.state.sfAccountText && this.state.sfAccountText.length >3 ? this.state.sfAccountLoading ? 'Loading...' : 'No accounts match your query.' : 'Enter 3 or more characters.'} style={{width: '150px'}} value={this.state.sfAccount} onInputChange={this.sfHandleAccountInputChange} inputValue={this.state.sfAccountText} onChange={this.sfHandleAccountChange}
                                className={this.state.sowBuilderClient.trim() === '' && this.state.hasSubmitted ? "invalid" : ""}
                                options= {this.state.accounts.map(function(account) {
                                  return {label:account.Name, value:account.Id}
                                })} />
                      </div>
                      :
                      <input
                          type="text"
                          className={this.state.sowBuilderClient.trim()  === '' && this.state.hasSubmitted ? "invalid" : ""}
                          value={this.state.sowBuilderClient}
                          placeholder="Client Name"
                          onChange={event => { this.handleSowBuilderClientChange(event) }} />}
                </div>
                : null}
            <div className="total">Total Price: <span style={{paddingLeft: '10px'}}>{`$${this.state.sowBuilderTotalPrice.toLocaleString()}`}</span></div>
            {/*<div className="total">Total Weeks: <span>{this.state.sowBuilderTotalWeeks}</span></div>*/}
          </div>
          <div className="download" id={this.getSowBuilderDownloadId()}>
            <div>
              <table cellSpacing={0} cellPadding={0} border={0} className="header">
              <tr>
                <td><img alt='' src="data:image/png;base64,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" className="logo" align="center" /></td>
                <td>
                  <div className="summary">
                    <div>Statement of Work #MO{moment().format('YYYYMMDD')}.V1</div>
                    <div>Prepared for {this.state.sowBuilderClient}</div>
                  </div>
                </td>
              </tr>
              </table>

              {this.state.sowBuilderSignature && (
                  <div className="signature">
                    <hr />
                    <div className="sep">
                      _____________________________________________________________________________________________________________
                    </div>
                    <div className="content">
                      <p
                          dangerouslySetInnerHTML={{
                            __html: this.toAscii(this.state.sowBuilderSignature)
                          }}
                      />
                    </div>
                  </div>
              )}
              {_.map(this.state.sowBuilderProducts, (product, p) => {
                return (
                    <div className="item" key={p} data-id={product.id}>
                      <div>&lt;Page Break&gt;</div>
                      {product.rows && _.map(product.rows, (row, r) => {
                        let value = row.control;
                        if (row.control && row.control[0] === '"') {
                          value = value.substring(1, row.control.length - 1);
                        }
                        if(['editor','text'].includes(row.row_type) && value && row.options.addToProposal) {
                          return (
                              <div className="productRow" key={`${p}_${r}`}>
                                {row.label !== "SOW Content" &&
                                <em>
                                  <h2>
                                    {row.label}
                                  </h2>
                                </em>}

                                <div>
                                  { ReactHtmlParser(this.toAscii(value).replace(/^"(.+)"$/,'$1').replace(/style="[^"]*"/g, "").replace(/\\"/g, "\"").replace(/\\n/g, '')) }
                                </div>
                                <div>
                                  <hr />
                                  <div className="sep">
                                    _____________________________________________________________________________________________________________
                                  </div>
                                </div>
                                {_.map(
                                    _.filter(row.options.items, { isChecked: true }),
                                    (option, o) => {
                                      return (
                                          <div className="option" key={`${p}_${r}_${o}`}>
                                            <div
                                                className={`sep ${o === 0 ? "first" : ""}`}
                                            >
                                              -
                                            </div>
                                            <h5>{option.label}</h5>
                                            {this.renderProductPriceTime(option, {option: true, download: true})}
                                            <p dangerouslySetInnerHTML={{__html: this.toAscii(option.description)}} />
                                          </div>
                                      );
                                    }
                                )}
                              </div>
                          );
                        }
                        else {
                          return null;
                        }
                      })}
                    </div>
                );
              })}
            </div>
          </div>


          <div className="preview" style={{maxHeight: this.state.sowBuilderPreviewHeight}}>
            {_.map(this.state.sowBuilderProducts, (product, p) => {
              return (
                  <div key={p}>
                    <h5><div className="remove" onClick={() => this.handleSowBuilderRemove(product)}></div>{product.name}</h5>
                    {this.renderProductPriceTime(product, {preview: true, quantity: true})}
                    <p dangerouslySetInnerHTML={{__html: product.description}}></p>

                    {/* product.rows.map(row => {
                      const options = this.state.selectedProductOptions[row.id];
                      if(!(options||[]).length) {
                        return null;
                      }
                      console.log(row.label === 'Sales Price')
                      return (
                          <div key={row.id} className="productRow">
                            <label>{row.label}</label>
                            { options && _.map(options, (option, o) => {
                              return (
                                  <div className="option" key={`${p}_${o}`}>
                                    <h5>{option.label}</h5>
                                    {this.renderProductPriceTime(option, {preview: true, option: true})}
                                    {option.description && <p dangerouslySetInnerHTML={{__html: option.description}}></p>}
                                  </div>
                              );
                            })}
                          </div>
                      )
                    }) */}
                  </div>
              );
            })}
          </div>

        </div>
    );
  }

  setSowBuilderSummaryRef(node) {
    this.sowBuilderSummaryRef = node;
  }

  sfHandleAccountChange(selection){
    this.setState({sfAccountText: undefined});
    this.setState({sowBuilderClient: selection.label});
    this.setState({sfAccount:selection});
  }

  sfHandleAccountInputChange(e, opts){
    if(opts.action === 'input-change'){
      this.setState({sfAccountLoading: true});
      this.setState({sfAccountText: e});
      if(e.length >= 3){
        conn.sobject("Account")
          .find(
            { Name : { $like : '%' + e + '%' } },
            { Id: 1,
              Name: 1,
              }
          )
          .execute(this.receiveRecords.bind(this));
      }
    }
  }

  receiveRecords(err,records){
    this.setState({sfAccountLoading: true});
    if (err) { return console.error(err); }
    this.setState({accounts: records});
  }

  pageCreateOpportunity(opp, docName, staffing, order, itemId){
    this.setState({isSfModalOpen: false});
    this.setState({sfLoading: true});
    this.props.sfCreateOpportunity(opp, this.state.sfWord, this.state.sfPdf, docName, staffing, order, this.handleError, itemId);
  }

  areFieldsValid(){
    return this.state.sfAccount !== undefined;
  }

  handleError(msg){
    this.setState({sfLoading: false});
    this.toggleSfModal();
    this.setState({finalMsg: msg});
  }

  clearError(){
    this.setState({oppError: null});
  }

  handleProposalQuoteCreate(proposal) {
    if(_.includes(proposal.status, 'quote')) {
      this.handleSowBuilderDownload(proposal, proposal.status.replace('quote','').toLowerCase());
    }
  }

  toggleSaveProposalDropdown() {
    this.setState({ createProposalDropdownOpen: !this.state.createProposalDropdownOpen });
  }

  submitProposal(submit, status) {
    this.setState({hasSubmitted: true, sowBuilderClientError: !this.state.sowBuilderClient || !this.state.sowBuilderDate}, function() {
      if (this.state.sowBuilderClientError) {
        return;
      }

      this.setState({ hasSubmitted: false, proposalSubmitting: true });
      const proposal = this.props.editProposal || {
        userId: this.props.user.id,
        companyId: this.props.data.company_id,
        parentId: this.props.data.id,
        parentType: 'catalog',
        status: status,
        type: 'proposal',
        settings: {
          issueDate: moment().toISOString(),
        },
      };
      proposal.name = `${this.state.sowBuilderClient} / ${this.props.data.company.name}`;
      proposal.settings = JSON.stringify(_.assign(proposal.settings, {
        value: this.state.sowBuilderTotalPrice * 100,
        clientName: this.state.sowBuilderClient,
        expiryDate: moment(this.state.sowBuilderDate).toISOString(),
        email: this.props.user.email,
        items: this.state.sowBuilderProducts.map(p => p.id),
        options: this.state.selectedProductOptions,
      }));

      //this.handleSowBuilderDownload(proposal, proposal.status.replace('quote','').toLowerCase());
      submit(proposal);
    })
  }

  createProposal(status) {
    this.submitProposal(this.props.proposalLazyCreate, status);
  }

  updateProposal() {
    this.submitProposal(this.props.proposalLazyUpdate);
  }

  toggleCreateProposalConfirm() {
    this.setState({ createProposalConfirmOpen: !this.state.createProposalConfirmOpen });
  }

  jumpCreateProposalConfirm() {
    this.toggleCreateProposalConfirm();
    this.setState({sowBuilderProducts: []});
    window.scrollTo(0, 0);
  }

  jumpCreateProposalConfirmProposals() {
    this.jumpCreateProposalConfirm();
    this.props.setPageProposals();
  }


  renderProposalBuilder() {
    const data = this.props.data;
    return (
        <div className={`proposalBuilder ${this.isSowBuilderPreviewShowing() ? "preview-showing" : ""}`}>
          <Container>
            {data.contents.items &&
            <Row className={`options sowBuilderEmpty`}>
              {(data.contents.items) &&
              <div className="search">
                <Input placeholder="Search" value={this.state.searchQuery} onChange={this.handleSearchQueryChange} />
                {this.state.searchQuery && <FontAwesomeIcon icon="times" onClick={this.handleSearchClear} />}
              </div>
              }

              {this.state.uniqueCategories &&
              <Select
                  isMulti
                  className="categories"
                  classNamePrefix="categories"
                  placeholder="Categories"
                  onChange={this.handleCategorySelect}
                  options={this.state.uniqueCategories.map(cat => ({label: cat.name, value: cat.id}))}
              />}

              <div className="listGridToggle">
                <Button className={classNames({ active: this.state.isGrid })} onClick={this.setGridView}><FontAwesomeIcon icon="th" /></Button>
                <Button className={classNames({ active: !this.state.isGrid })} onClick={this.setListView}><FontAwesomeIcon icon="list-ul" /></Button>
              </div>
              {this.state.priceMax > 0 && <div className={"price" + (this.isPriceFiltered() ? " filtered" : "")}>
                <InputRange
                    maxValue={this.state.priceMax}
                    minValue={0}
                    step={1}
                    formatLabel={this.formatPriceFilterLabel}
                    value={this.state.priceFilter}
                    onChange={this.setPriceFilter} />
              </div>}
            </Row>}
            {this.getItems()}
          </Container>
        </div>
    );
  }



  renderProductDetail(item) {
    return (
        <ProductDetail
            selectedOptions = { this.state.selectedProductOptions}
            hasSubmitted = {this.state.hasSubmitted}
            setSfModalListener = {this.setSfModalListener}
            sfLoading={this.state.sfLoading}
            finalMsg={this.state.finalMsg}
            totalCost ={this.state.sowBuilderTotalPrice}
            selectedProducts = {this.state.sowBuilderProducts}
            sfCreateOpportunity={this.pageCreateOpportunity}
            requestedOpenOpp={this.state.hasSubmitted}
            sowBuilderDate={this.state.sowBuilderDate}
            sowBuilderTerm={this.state.sowBuilderTerm}
            getProductOptionState={this.getProductOptionState}
            sowBuilderHoursPerMonth={this.state.sowBuilderHoursPerMonth}
            sowBuilderOverageHours={this.state.sowBuilderOverageHours}
            sowBuilderOppName={this.state.sowBuilderOppName}
            getSfData={this.props.getSfData}
            proposalLazyCreate={this.props.proposalLazyCreate}
            clearError={this.clearError}
            sfAccount={this.state.sfAccount}
            isSfModalOpen={this.state.isSfModalOpen}
            toggleSfModal={this.toggleSfModal}
            isSalesforce={this.props.isSalesforce}
            isLoggedIn={this.props.isLoggedIn}
            isDimmed={this.props.isDimmed}
            productRowsFetch={this.props.productRowsFetch}
            productRowsLazyFetch={this.props.productRowsLazyFetch}
            log_transaction={this.props.log_transaction}
            data={item}
            setPageDetail={this.props.setPageDetail}
            backToPage={this.backToPage}
            renderProductPriceTime={this.renderProductPriceTime}
            getSowBuilderSummary={this.getSowBuilderSummary}
            setSowBuilderPreviewHeight={this.setSowBuilderPreviewHeight}
            isSowBuilderPreviewShowing={this.isSowBuilderPreviewShowing}
            isSowBuilderEmpty={this.isSowBuilderEmpty}
            isSowBuilderLimit={this.isSowBuilderLimit}
            toggleSowBuilderPreview={this.toggleSowBuilderPreview}
            isSowBuilderAdded={this.isSowBuilderAdded}
            handleSowBuilderAdd={this.handleSowBuilderAdd}
            handleSowBuilderRemove={this.handleSowBuilderRemove}
            buildSowBuilderDownloadVariableTagRegex={this.buildSowBuilderDownloadVariableTagRegex}
            handleProductOptionSelection={this.handleProductOptionSelection}
            selectedProductOptions={this.state.selectedProductOptions}
        />
    );
  }




  render() {
    if(this.props.editProposal) {
      if(this.props.detailItem) {
        return this.renderProductDetail(this.props.detailItem);
      }
      else {
        return this.renderProposalBuilder();
      }
    }

    return (
        <div>
          <Switch>
            <Route
                path="/item/:id"
                render={({match}) => {
                  return this.renderProductDetail(_.find(this.props.data.contents.items, {id: match.params.id}));
                }}
            />
            <Route
                path="/"
                render={() => {
                  return this.renderProposalBuilder();
                }}
            />
          </Switch>
        </div>
    );
  }

}

export default withRouter(ProposalBuilder);
